/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  mapGetters,
  mapState
} from 'vuex';

import {
  bus
} from '../../main';
import toast from '../../services/toast';

export default {
  name: 'course-category',
  components: {},
  data() {
    return {
      courses: {},
      courseListResults: [],
      categoryList: {},
      categoryFilterName: '',
      id: '',
      preloader: true,
      loader: false,
      deleteCourseId: '',
      isRoleIn:''
    }
  },
  computed: {
    ...mapGetters([
      'getCourseByCategoryState',
      'getCategoryListState',
      'getCourseByCategoryState',
    ]),
    getCategory() {
      this.categoryList = this.$store.getters.getCategoryListState;
      return this.categoryList
    },
    getCourseByCatgoryByActn() {
      this.$store.dispatch('getCategoryDetailsById', {
        id: this.$route.params.id
      }).then((response) => {
        if (response.data.code == '2000') {
          this.categoryFilterName = response.data.data.name
        }
      })
    },
    getAllCourses() {
      this.loader = true;
      this.$store.dispatch('CourseByCategoryAction', {
        id: this.$route.params.id
      }).then((response) => {
        if (response.data.code == '2000') {
          this.loader = false
          this.courses = this.$store.getters.getCourseByCategoryState
          console.log(response.data)
          return this.courses;
        }
      })
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.courseListResults = this.courses.results
      }
    },
    getUserDetails() {
      this.$store.dispatch('getUserRoleDetails').then((res) => {
        this.isRoleIn = res.data.data.profile.role
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getUserDetails
    this.getCourseByCatgoryByActn
    this.getCategory
    this.getAllCourses
    this.SetIntialStatus
  },
  methods: {
    viewCourseDetailsFun(id) {
      this.$router.push('/course/' + id + "/tab/")
    },
    getCoursebyCategory(id, name) {
      this.loader = true;
      if (id != "") {
        this.$router.push('/usercourses/category/' + id + "/")
        this.loader = false;
      } else {
        this.$router.push('/courses/')
        this.loader = false;
      }
      this.categoryFilterName = name;
    },
    deleteCourseFun(id) {
      this.deleteCourseId = id
      $('#removeCourseModal').modal()
    },
    removeCourseModalConfirmation() {
      let data = {
        id: this.deleteCourseId
      }
      this.$store.dispatch('removeCourseFun', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            this.getCourseDetailsAgain()
            toast.success(res.data.msg);
          }
        })
        .catch((err) => {})
    }

  },
  watch: {
    getCategory() {
      return this.$store.getters.getCategoryListState
    },
    getAllCourses() {
      return this.$store.getters.getCourseByCategoryState;
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.courseListResults = this.courses.results
      }
    }
  }
}